module.exports = __webpack_public_path__ + "img/cake-11.72de3b28.svg";